import { BaseSingleton, singleton } from "@core/foundation/class";

import type { AuthorizerContract } from "./AuthorizerContract.ts";

type Contract = AuthorizerContract<"public", {}>;

class PublicAuthorizer extends BaseSingleton implements Contract {
  public static readonly getInstance = singleton(() => new PublicAuthorizer());

  public readonly __typeTag = "AuthorizerContract";

  public readonly type = "public";

  public readonly authorize: Contract["authorize"] = () => {
    return {};
  };
}

export const publicAuthorizer = PublicAuthorizer.getInstance();
